import React from 'react';
import TextInput from 'shared/components/TextInput';

const ParametersChanged = (props) => {
  const { parametersChanged } = props;

  return (
    <TextInput
      type="hidden"
      name="parameters_changed"
      inputClassName="parameter-changed"
      value={parametersChanged ? '1' : ''}
      groupName="" />
  );
};

export default ParametersChanged;
